(() => {
  if (window.tumzaroV22ProductReady) return;
  window.tumzaroV22ProductReady = true;

  const initialize = (root) => {
    const form = document.getElementById(root.dataset.formId);
    if (!form) return;
    const buyNow = root.querySelector('[data-v22-buy-now]');
    let buying = false;
    const quantity = form.querySelector('[data-v22-quantity-input]');
    const selectedVariant = () => form.querySelector('[data-v22-variant]:checked') || form.querySelector('[data-v22-variant][type="hidden"]');
    const purchaseButtons = () => Array.from(document.querySelectorAll('[data-v22-add]')).filter((button) => button.form === form);
    const summaryNodes = () => Array.from(document.querySelectorAll('[data-v22-selection-summary]')).filter((node) => node.dataset.productId === root.dataset.productId);
    const normalizeQuantity = () => {
      const minimum = Number(quantity.min) || 1;
      const step = Number(quantity.step) || 1;
      const maximum = quantity.max ? Number(quantity.max) : Infinity;
      const entered = Number(quantity.value);
      const value = Number.isFinite(entered) ? entered : minimum;
      let normalized = minimum + Math.max(0, Math.round((value - minimum) / step)) * step;
      if (normalized > maximum) normalized = minimum + Math.floor((maximum - minimum) / step) * step;
      quantity.value = String(Math.max(minimum, normalized));
      root.querySelector('[data-v22-quantity="-1"]').disabled = Number(quantity.value) <= minimum;
      root.querySelector('[data-v22-quantity="1"]').disabled = Number(quantity.value) + step > maximum;
    };
    const updateSummary = () => {
      const variant = selectedVariant();
      if (!variant) return;
      const summary = root.dataset.summaryPattern
        .replace('__OPTION__', variant.dataset.title)
        .replace('__QUANTITY__', quantity.value || quantity.min || '1')
        .replace('__PRICE__', variant.dataset.price);
      summaryNodes().forEach((node) => { node.textContent = summary; });
    };
    const activateMedia = (mediaId) => {
      if (!mediaId || !root.querySelector(`[data-v22-media][data-media-id="${mediaId}"]`)) return;
      root.querySelectorAll('[data-v22-media]').forEach((media) => {
        const active = media.dataset.mediaId === mediaId;
        media.hidden = !active;
        if (!active) {
          media.querySelectorAll('video').forEach((video) => video.pause());
          media.querySelectorAll('iframe').forEach((frame) => {
            if (frame.src.includes('youtube.com') || frame.src.includes('youtube-nocookie.com')) {
              frame.contentWindow?.postMessage(JSON.stringify({ event: 'command', func: 'pauseVideo', args: [] }), new URL(frame.src).origin);
            } else if (frame.src.includes('player.vimeo.com')) {
              frame.contentWindow?.postMessage(JSON.stringify({ method: 'pause' }), new URL(frame.src).origin);
            }
          });
        }
      });
      root.querySelectorAll('[data-v22-thumb]').forEach((button) => {
        const active = button.dataset.mediaId === mediaId;
        button.classList.toggle('active', active);
        button.setAttribute('aria-pressed', String(active));
      });
    };
    const updateStockOffer = (variant) => {
      const offer = root.querySelector('[data-v22-stock-offer]');
      if (!offer) return;
      const inventory = Math.max(0, Number.parseInt(variant.dataset.inventory || '0', 10) || 0);
      const stockFloor = Math.max(90, Math.min(93.6, Number.parseFloat(offer.dataset.stockFloor || '90') || 90));
      const soldPercent = variant.dataset.available === 'true'
        ? Math.min(99.9, stockFloor + Math.max(0, 6 - Math.min(6, inventory)) * (100 - stockFloor) / 6)
        : 100;
      const displayPercent = Number.isInteger(soldPercent) ? String(soldPercent) : soldPercent.toFixed(1);
      const percent = offer.querySelector('[data-v22-stock-percent]');
      const progress = offer.querySelector('[data-v22-stock-progress]');
      const fill = progress?.querySelector('span');
      const saving = offer.querySelector('[data-v22-stock-saving]');
      if (percent) percent.textContent = displayPercent;
      if (progress) progress.setAttribute('aria-valuenow', displayPercent);
      if (fill) fill.style.width = `${soldPercent}%`;
      if (saving) {
        const savingMoney = variant.dataset.savingsMoney || '';
        saving.hidden = !savingMoney;
        saving.textContent = savingMoney ? `Save ${savingMoney}` : '';
      }
    };
    const syncVariant = (updateUrl = false) => {
      const variant = selectedVariant();
      if (!variant) return;
      const price = root.querySelector('[data-v22-price]');
      price.replaceChildren(document.createTextNode(variant.dataset.price));
      if (variant.dataset.comparePrice) {
        const comparePrice = document.createElement('s');
        comparePrice.textContent = variant.dataset.comparePrice;
        price.append(document.createTextNode(' '), comparePrice);
                if (variant.dataset.savingsMoney) {
          const saving = document.createElement('span');
          saving.className = 'v22-price-saving';
          saving.dataset.v22PriceSaving = '';
          saving.textContent = `Save ${variant.dataset.savingsMoney}`;
          price.append(document.createTextNode(' '), saving);
        }
      }
      root.querySelectorAll('.option').forEach((option) => {
        option.classList.toggle('active', Boolean(option.querySelector('[data-v22-variant]:checked')));
      });
      purchaseButtons().forEach((button) => {
        button.disabled = buying || variant.dataset.available !== 'true';
        button.textContent = button.disabled ? root.dataset.soldOutLabel : button.dataset.addLabel || root.dataset.addLabel;
      });
      if (buyNow) buyNow.disabled = buying || variant.dataset.available !== 'true';
      const selectionNote = root.querySelector('[data-v22-selection-note]');
      if (selectionNote) selectionNote.textContent = root.dataset.selectionNote.replace('__OPTION__', variant.dataset.title);
      quantity.min = variant.dataset.min || '1';
      quantity.step = variant.dataset.step || '1';
      if (variant.dataset.max) quantity.max = variant.dataset.max;
      else quantity.removeAttribute('max');
      normalizeQuantity();
      updateStockOffer(variant);
      activateMedia(variant.dataset.mediaId);
      updateSummary();
      if (updateUrl) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.value);
        window.history.replaceState({}, '', url);
      }
    };
    root.v22SyncSelection = () => syncVariant(false);
    if (root.dataset.v22Ready === 'true') {
      syncVariant();
      return;
    }
    root.dataset.v22Ready = 'true';
    root.querySelectorAll('[data-v22-thumb]').forEach((button) => {
      button.addEventListener('click', () => activateMedia(button.dataset.mediaId));
    });
    form.querySelectorAll('[data-v22-variant]').forEach((input) => {
      input.addEventListener('change', () => syncVariant(true));
    });
    root.querySelectorAll('[data-v22-quantity]').forEach((button) => {
      button.addEventListener('click', () => {
        quantity.value = String((Number(quantity.value) || Number(quantity.min) || 1) + Number(button.dataset.v22Quantity) * (Number(quantity.step) || 1));
        normalizeQuantity();
        updateSummary();
        quantity.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
    buyNow?.addEventListener('click', async () => {
      const variant = selectedVariant();
      if (buying || !variant || variant.dataset.available !== 'true' || purchaseButtons().some(button => button.disabled)) return;
      normalizeQuantity();
      if (!form.reportValidity()) return;
      const status = form.querySelector('[role="status"]');
      if (status) status.textContent = '';
      const payload = new FormData(form);
      buying = true;
      buyNow.disabled = true;
      buyNow.setAttribute('aria-busy', 'true');
      buyNow.textContent = buyNow.dataset.loadingLabel;
      purchaseButtons().forEach(button => { button.disabled = true; });
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: payload });
        const data = await response.json();
        if (!response.ok) { const failure = new Error(typeof data.description === 'string' ? data.description : buyNow.dataset.errorLabel); failure.cartRejected = true; throw failure; }
        // Preserve existing cart lines. Shopify validates stock and checkout eligibility.
        window.location.assign(`${window.Shopify?.routes?.root || '/'}checkout`);
      } catch (error) {
        if (status) status.textContent = error.cartRejected ? error.message : buyNow.dataset.errorLabel;
        buying = false;
        buyNow.removeAttribute('aria-busy');
        buyNow.textContent = buyNow.dataset.buyLabel;
        syncVariant();
      }
    });
    window.addEventListener('pageshow', () => {
      buying = false;
      if (buyNow) { buyNow.removeAttribute('aria-busy'); buyNow.textContent = buyNow.dataset.buyLabel; }
      syncVariant();
    });
    quantity.addEventListener('input', updateSummary);
    quantity.addEventListener('change', () => { normalizeQuantity(); updateSummary(); });
    form.addEventListener('submit', () => {
      normalizeQuantity();
      updateSummary();
      const status = form.querySelector('[role="status"]');
      if (status) status.textContent = '';
    });
    const status = form.querySelector('[role="status"]');
    if (status) {
      const observer = new MutationObserver(() => {
        document.querySelectorAll('[data-v22-final-status]').forEach((node) => { node.textContent = status.textContent; });
      });
      observer.observe(status, { childList: true, characterData: true, subtree: true });
    }
    syncVariant();
  };
  const initializeAll = () => document.querySelectorAll('[data-v22-product]').forEach(initialize);
  initializeAll();
  document.addEventListener('shopify:section:load', initializeAll);
})();
